module.exports = __webpack_public_path__ + "img/ro.21932553.svg";